<template>
  <div class="pc-list-cell">
    <div class="type-name">
      <span class="type-text">{{ alias[axData.platform] }}</span>
    </div>
    <div class="cell-content">
      <h6>{{ axData.title }}</h6>
      <p>{{ axData.applyDateTime | moment('YYYY/MM/DD HH:mm:ss')}}</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from "vue-moment";
Vue.use(moment);
export default {
  components: {},
  props: {
    axData: Object,
  },
  data() {
    return {
      alias: {
        SSC: '共享服务',
        EHR: '人力',
        FK: '费用报销',
        HULK: '其他',
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.pc-list-cell {
  cursor: pointer;
  display: flex;
  padding: 20px;
  position: relative;
  align-items: center;
  &:after {
    position: absolute;
    left: 76px;
    right: 20px;
    bottom: 0;
    content: ' ';
    box-sizing: border-box;
    border-bottom: 1px solid $border-color;
    transform: scaleY(0.5);
  }
  .type-name {
    font-size: 14px;
    color: #fff;
    display: flex;
    justify-content: center;
    .type-text{
      box-sizing: border-box;
      width: 40px;
      height: 40px;
      background: #1485EE;
      border-radius: 4px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: 4px;
      letter-spacing: 3px;
    }
    margin-right: 10px;
  }
  .cell-content {
    flex: 1;
    h6 {
      font-size: 14px;
      height: 20px;
      line-height: 20px;
      color:rgba(34,34,34,1);
      font-weight: normal;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 190px;
      margin-bottom: 3px;
    }
    p {
      height: 14px;
      line-height: 14px;
      font-size: 12px;
      color: #999999;
    }
  }
}
</style>
